module.exports = __webpack_public_path__ + "img/avatar_admin.c42d77fe.png";